import React, { useState } from "react";

export function TextareaComponent() {
  const [text, setText] = useState("");

  const handleChange = (e) => {
    setText(e.target.value);
  };

  return (
    <textarea
      value={text}
      onChange={handleChange}
      placeholder="Escribe aqui..."
      className="w-full px-3 py-2 border rounded-md"
    />
  );
}
